module.exports = __webpack_public_path__ + "static/media/teaserhero-left-template.9ab445d7.svg";